export default {
  // 图集详情接口
  getGalleryDetailById: '/amc/client/getAtlasContentById',
}